var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseButton',{class:_vm.$style.logout,attrs:{"type":"black","small":"","outlined":true},nativeOn:{"click":function($event){return _vm.logout.apply(null, arguments)}}},[_c('IconSelect',{attrs:{"icon":"lock","height":"18","width":"18"}}),_c('span',{class:_vm.$style.text},[_vm._v(_vm._s(_vm.$t('app.logout')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }